import type { SanityPageBuilderMediaHighlightsItem, SanityPageBuilderMediaHighlightsSection, SanityPageBuilderSection } from "@ouster/shared";
import { MediaHighlightsBlockView } from "~/features/blocks/inventory/media-highlights";
import { toCraftLinkArray } from "~/features/sanity/link";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
import { SanityMediaFigure, hasRenderableSanityMedia } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderMediaHighlightsSection;
  };
};
export function SanityMediaHighlightsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const highlights = sectionContent.highlights?.map((highlight: SanityPageBuilderMediaHighlightsItem) => ({
    left: highlight.left,
    right: highlight.right
  })) ?? [];
  // The block view stacks its copy in normal flow when no media is passed, so the
  // slots must stay empty instead of holding a figure that renders nothing.
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  return <MediaHighlightsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} eyebrow={sectionContent.eyebrow} hasSolidBackground={sectionContent.hasSolidBackground} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} highlights={highlights} isHighlighted={sectionContent.isHighlighted} link={toCraftLinkArray(sectionContent.link)} mediaDesktop={hasMedia ? <SanityMediaFigure media={sectionContent.media} ratio="2/1" sizes="lg:50vw" /> : undefined} mediaMobile={hasMedia ? <SanityMediaFigure media={sectionContent.media} ratio="5/6" sizes="100vw" /> : undefined} mode={mode} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type,
    // Excludes every image inside this section from the route-level image
    // parallax (ParallaxImg checks closest("[data-noparallax]")).
    "data-noparallax": sectionContent.disableImageParallax ? "" : undefined
  }} theme={theme} title={sectionContent.title} />;
}